import { useEffect, useState } from 'react'
import {
    Col,
    Footer,
    Header,
    JobInfo,
    JobLog,
    JobMap,
    SearchForm,
    Spinner,
} from './components'
import { JOB_STATUS } from './constants'
import {
    useAddresses,
    useCourierLocation,
    useScrollTopValue,
    useTrackingDetailsApi,
    useUrlParams,
} from './hooks'
import { Job } from './interfaces'

export const TRACKING_ID_INPUT = 'TRACKING_ID_INPUT'

const displayJobMap = (job: Job) => {
    if (job.isMapHidden) {
        return false
    }

    const DisplayMapTo = {
        status: [JOB_STATUS.pickup, JOB_STATUS.deliver],
        stopStatusCompleted: [JOB_STATUS.arrivedAt],
    }

    if (DisplayMapTo.status.includes(job.status)) {
        return true
    }
    if (DisplayMapTo.stopStatusCompleted.includes(job.status)) {
        if (job.stops?.[0]?.stopStatus === JOB_STATUS.completed) {
            return true
        }
    }

    return false
}

export const App = () => {
    const { customer, trackingId: urlTrackingId } = useUrlParams()
    const [trackingId, setTrackingId] = useState(urlTrackingId)
    const [submitCount, setSubmitCount] = useState(-1)
    const { job, isLoading, isStarted } = useTrackingDetailsApi(
        customer.toLowerCase(),
        trackingId,
        submitCount,
    )
    const scrollTop = useScrollTopValue()

    useEffect(() => {
        if (job) {
            window.scrollTo({
                top: scrollTop,
                left: 0,
                behavior: 'smooth',
            })
        }
    }, [job, scrollTop])

    const onJobSearch = (trackingId: string, submitCount: number) => {
        setTrackingId(trackingId)
        setSubmitCount(submitCount)
    }
    const { collection, delivery } = useAddresses(job?.stops)
    const error = !job && !isLoading && isStarted
    const errorMessage = 'No tracking details found'
    const displayDetails = !isLoading && job
    const courierLocation = useCourierLocation(job?.driver)

    return (
        <Col className="w-full items-center">
            <div className="w-full">
                <Header />
            </div>
            <div className="bg-brand-header-image bg-center bg-cover w-full h-36 sm:h-64 lg:h-96 mt-28" />
            <Col className="w-full max-w-3xl items-center px-1">
                <div className="w-full max-w-xl mb-8">
                    <SearchForm
                        onSearch={onJobSearch}
                        trackingId={urlTrackingId}
                        customer={customer}
                        error={error}
                        errorMessage={errorMessage}
                        isLoading={isLoading}
                    />
                </div>
                {isLoading && <Spinner variant="large" className="my-24" />}
                {job && displayJobMap(job) && (
                    <div className="w-full mb-8">
                        <JobMap
                            markers={{
                                collection: collection?.location,
                                delivery: delivery?.location,
                                courier:
                                    job?.status === JOB_STATUS.deliver
                                        ? undefined
                                        : courierLocation,
                            }}
                        />
                    </div>
                )}
                {displayDetails && (
                    <div className="w-full mb-8">
                        <JobInfo job={job} trackingId={trackingId} />
                    </div>
                )}
                {displayDetails && (
                    <div className="w-full mb-8">
                        <JobLog jobAudit={job?.jobAudit} />
                    </div>
                )}
            </Col>
            <div className="w-full">
                <Footer />
            </div>
        </Col>
    )
}
